export type LifestyleInput = { commute_km: number; remote_days: number; home_energy_kWh: number; privacy?: boolean };
export type LifestyleOutput = { grade: 'A'|'B'|'C'|'D'|'E'; masked: boolean };

export function computeLifestyleScore(i: LifestyleInput): LifestyleOutput {
  const commute = Math.max(0, 100 - i.commute_km / 10);
  const remote = Math.min(100, i.remote_days * 15);
  const energy = Math.max(0, 100 - i.home_energy_kWh / 20);
  const score = 0.4*commute + 0.3*remote + 0.3*energy;
  const grade = score>80?'A': score>65?'B': score>50?'C': score>35?'D':'E';
  return { grade, masked: !!i.privacy };
}



















